import HotelInfo from './HotelInfo';

export default HotelInfo;
